export function RandomNumber() {
  const min = 1;
  const max = 100;
  return (min + Math.random() * (max - min));
}
